import utils from '../utils';

describe('utils', () => {
  it('should have the required properties', () => {
    expect(utils).toHaveProperty('dataLoadToRoute');
    expect(utils).toHaveProperty('routeToDataLoad');
    expect(utils).toHaveProperty('translateColumnName');
  });
});
